

import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ApiUrl } from "../Constants/Weburl";
import { adminforgetpassword } from "../services/reactapis";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setError("");

    try {
      setLoading(true);

      const data = await adminforgetpassword(email);

      setMsg(data.message);
    } catch (err) {
      setError(
        err.response?.data?.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-page">
      <div className="forgot-card">

        <div className="forgot-icon">
          <svg
            width="34"
            height="34"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#f9a825"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="5" width="18" height="14" rx="3" />
            <path d="m3 7 9 6 9-6" />
          </svg>
        </div>

        <p className="forgot-label">ADMIN PORTAL</p>

        <h2>Forgot password?</h2>

        <p className="forgot-description">
          No worries! Enter your admin email address and
          we'll send you instructions to reset your password.
        </p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="admin-email">
            Email address
          </label>

          <div className="forgot-input-wrap">
            <input
              id="admin-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@example.com"
              disabled={loading}
            />
          </div>

          {msg && (
            <div className="forgot-alert success-alert" role="status">
              <span>✓</span>
              <p>{msg}</p>
            </div>
          )}

          {error && (
            <div className="forgot-alert error-alert" role="alert">
              <span>!</span>
              <p>{error}</p>
            </div>
          )}

          <button
            type="submit"
            className="forgot-submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="forgot-spinner" />
                Sending reset link...
              </>
            ) : (
              <>
                Send reset link
                <span className="forgot-arrow">→</span>
              </>
            )}
          </button>
        </form>

        <div className="forgot-divider">
          <span />
          <span>SECURE ADMIN ACCESS</span>
          <span />
        </div>

        <Link to="/" className="forgot-back">
          <span>←</span> Back to Login
        </Link>

      </div>

      <p className="forgot-footer">
        © {new Date().getFullYear()} Admin Portal. All rights reserved.
      </p>
    </div>
  );
}
